import type React from 'react';

import { useRef } from 'react';

import { HeaderSearch } from '../../../base/components/Header';
import EcommerceProductSearchStateContextProvider from '../../contexts/ecommerceProductSearchStateContext';
import { SearchAbTestProvider } from '../../contexts/searchAbTestContext';
import EcommerceSearchBar from '../EcommerceSearchBar';
import EcommerceSearchOverlay from '../EcommerceSearchBar/EcommerceSearchOverlay';

const EcommerceSearch = (props: React.PropsWithChildren) => {
    const searchInputRef = useRef<HTMLInputElement>(null);

    return (
        <SearchAbTestProvider>
            <EcommerceProductSearchStateContextProvider initialQuery="">
                <HeaderSearch searchSlot={<EcommerceSearchBar ref={searchInputRef} />} />
                <EcommerceSearchOverlay type="ecommerce" triggerRef={searchInputRef} />

                {props.children}
            </EcommerceProductSearchStateContextProvider>
        </SearchAbTestProvider>
    );
};

export default EcommerceSearch;
